import { useTranslation } from 'react-i18next';

import { CarsSearchForm } from '@frontend/features/travel-services/components/CarsSearchForm';
import { TravelServicesPage } from '@frontend/features/travel-services/components/TravelServicesPage';
import { useSearchFormKey } from '@frontend/features/travel-services/useSearchUrlState';

/** Buscador de alquiler de autos (vertical cars de Rutero). */
export const Cars = () => {
  const { t } = useTranslation();
  // Aplicar una búsqueda reciente remonta el buscador: si no, los campos
  // (que se llenan al montar) quedarían vacíos bajo los resultados nuevos.
  const formKey = useSearchFormKey();

  return (
    <TravelServicesPage
      title={t('common.nav.cars')}
      intro={t('travelServices.carsIntro')}
    >
      <CarsSearchForm key={formKey} />
    </TravelServicesPage>
  );
};

export default Cars;
